export default __webpack_public_path__ + "static/media/truBeeRemovalMobile.fe917dd5.jpg";